<template>
  <div class=" position-relative d-flex flex-wrap justify-content-center align-items-center w-100">
    <div class="d-flex flex-wrap justify-content-center align-items-center">
      <div class="userImage position-relative rounded-pill atm-shadow">
        <img
          :src="require(`@/assets/avatar.png`)"
          alt="user image"
          class="w-100 h-100"
        />
      </div>
      <div class="userData position-relative d-flex justify-content-between align-items-center atm-shadow rounded-pill ">
        <div class=" d-flex align-items-center bg-main text-sm rounded-pill px-3 pl-5 h-100">
          <div class="badgeContainer d-flex align-items-center mr-1">
            <img :src="userLevel.photo" alt="Badge icon" />
          </div>
          <label class="text-light text-capitalize m-0">
            Level {{ userLevel.number }}
          </label>
        </div>
        <p class="text-center text-sm font-weight-600 m-0 mx-3">
          {{ userPoints }} pts
        </p>
      </div>
    </div>
    <div
      v-if="pointsToNextRank !== 'none'"
      class="levelupStyle d-flex justify-content-center align-items-center bg-main text-light rounded-pill"
    >
      <span>{{ pointsToNextRank }}</span>
      <span class="material-icons-round align-middle"> arrow_upward </span>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    isBack: Boolean,
    pointsToNextRank: String,
    userPoints: Number,
    userLevel: { 
      type: Object, 
      default: () => { return { photo: '', number: 0 }}
    },
  },
}
</script>
<style lang="scss">
.badgeContainer {
  width: 20px;
  height: 20px;
  & > img {
    fill: white;
    width: 20px;
    height: 20px;
  }
}
.userImage {
  background-color: white;
  width: 74px;
  height: 74px;
  z-index: 100;

  & > img {
    object-fit: contain;
  }
}
.userData {
  height: 30px;
  left: -2.5rem;
  z-index: 10;
}

.levelupStyle {
  height: 60px;
  width: 60px;
}
</style>